import imageBg from "../../img/home_bg.svg";

const featuresStyles = (theme) => ({
  card: {
    boxShadow: "unset",
  },
  gridBg: {
    background: `url(${imageBg})`,
    [theme.breakpoints.up("md")]: {
      backgroundSize: "contain",
      backgroundPosition: "top center",
      backgroundColor: theme.palette.common.darkGreybg,
    },
    [theme.breakpoints.up("xl")]: {
      backgroundRepeat: "no-repeat",
    },
    [theme.breakpoints.down("xl")]: {
      // background: `unset`,
      // backgroundColor: theme.palette.common.darkGreybg,
    },
  },
  cardContent: {
    padding: 0,
    // paddingTop: theme.spacing(3),
    paddingBottom: 0,
  },
  sectionBg: {
    backgroundColor: theme.palette.common.darkGreybg,
    height: 600,
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      paddingRight: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      height: 600,
    },
    [theme.breakpoints.between("xs", "sm")]: {
      height: 570,
    },
  },
  section2: {
    backgroundColor: theme.palette.common.white,
    // height: 400,
    paddingTop: theme.spacing(3.5),
    paddingBottom: theme.spacing(2.5),
    // paddingRight:theme.spacing(4),
    // paddingLeft:theme.spacing(4),
  },
  section3: {
    backgroundColor: theme.palette.common.darkGreybg,
    minHeight: 400,
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
    paddingRight: theme.spacing(8),
    paddingLeft: theme.spacing(8),
  },
  secCard: {
    border: "1px solid " + theme.palette.common.darkGrey,
    boxSizing: "border-box",
    borderRadius: 10,
    height: 400,
    boxShadow: "unset",
    background: "unset",
  },
  section4: {
    backgroundColor: theme.palette.common.white,
    minHeight: 400,
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
    paddingRight: theme.spacing(8),
    paddingLeft: theme.spacing(8),
  },
  menuItemText: {},
  mainCaption: {
    margin: "0 auto",
    width: "45%",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  mainTitle: {
    margin: "0 auto",
    width: "80%",
    textAlign: "center",
    color: "textPrimary",
    fontWeight: "700",
    fontSize: "1.25rem",
    textTransform: "uppercase",
    [theme.breakpoints.up("md")]: {
      fontSize: "2.75rem",
    },
  },
  featuresAndBenefitsOnline: {
    width: "100%",
    // height: 220,
    [theme.breakpoints.down("lg")]: {
      width: "80%",
      // paddingTop: theme.spacing(3)
    },
  },
  featuresAndBenefitsAdvantage: {
    width: "100%",
    // height: 220,
    [theme.breakpoints.down("lg")]: {
      width: "80%",
      // paddingTop: theme.spacing(3)
    },
  },
  featuresAndBenefitsTransparency: {
    width: "100%",
    // height: 220,
    [theme.breakpoints.down("lg")]: {
      width: "80%",
      // paddingTop: theme.spacing(3)
    },
  },
  featuresAndBenefitsChanges: {
    width: "100%",
    // height: 220,
    [theme.breakpoints.down("lg")]: {
      width: "80%",
      // paddingTop: theme.spacing(3)
    },
  },
});

export default featuresStyles;
